import { JmsdfUnitInfo } from "./JmsdfUnitInfo";

/**
 * 配送先情報の種類
 */
export const DestinationInfoType = {
    /**
     * 海上自衛隊
     */
    MaritimeDestinationInfo: "MaritimeDestinationInfo",
    /**
     * BtoB
     */
    BusinessDestinationInfo: "BusinessDestinationInfo",
    /**
     * BtoC
     */
    CustomerDestinationInfo: "CustomerDestinationInfo",
} as const;
export type DestinationInfoType = typeof DestinationInfoType[keyof typeof DestinationInfoType];

export interface BaseDestinationInfo {
    type: DestinationInfoType;
};

export interface MaritimeDestinationInfo extends BaseDestinationInfo {
    transportRequestUnit: JmsdfUnitInfo;
};

export interface CivilDestinationInfo extends BaseDestinationInfo {
    /**
     * メンバータイプがguestの場合空文字
     * メンバータイプがmemberの場合メンバーIDが入る
     */
    id: string,

    /**
     * 名前
     */
    firstname: string,

    /**
     * 苗字
     */
    lastname: string,

    /**
     * 県
     */
    prefecture: string,
    /**
     * 市住所
     */
    city: string,

    /**
     * 市以降の住所
     */
    address: string,

    /**
     * 郵便番号
     */
    zipcode: string,

    /**
     * 電話番号
     * （電話番号またはメールアドレスは必須）
     */
    tel?: string,
    /**
     * 第2電話番号　（店員用電話番号）
     */
    tel2?: string,
    /**
     * 第3電話番号　（不使用）
     */
    tel3?: string,
    /**
     * メールアドレス
     * （電話番号またはメールアドレスは必須）
     */
    mailaddress?: string
};

export interface BusinessDestinationInfo extends CivilDestinationInfo {
    companyName: string;
    departmentName?: string;
};

export interface CustomerDestinationInfo extends CivilDestinationInfo {
};

/**
 * 海上自衛隊の配送先情報のデフォルト値を作成する
 * @returns 
 */
export function createDefaultMaritimeDestinationInfo(): MaritimeDestinationInfo {
    return {
        type: DestinationInfoType.MaritimeDestinationInfo,
        transportRequestUnit: {
            unitName: "",
            lastname: "",
            firstname: "",
            tel: "",
            mailaddress: "",
        },
    };
};

/**
 * BtoBの配送先情報のデフォルト値を作成する
 * @returns 
 */
export function createDefaultBusinessDestinationInfo(): BusinessDestinationInfo {
    return {
        type: DestinationInfoType.BusinessDestinationInfo,
        id: "",
        firstname: "",
        lastname: "",
        prefecture: "",
        city: "",
        address: "",
        zipcode: "",
        tel: "",
        companyName: "",
        departmentName: ""
    };
};

/**
 * BtoCの配送先情報のデフォルト値を作成する
 * @returns 
 */
export function createDefaultCustomerDestinationInfo(): CustomerDestinationInfo {
    return {
        type: DestinationInfoType.CustomerDestinationInfo,
        id: "",
        firstname: "",
        lastname: "",
        prefecture: "",
        city: "",
        address: "",
        zipcode: "",
        tel: "",
        mailaddress: ""
    };
};